export const csfReg = /^csf:/;
export const fiDevgrpRegex = new RegExp('^' + MACROS.DVM.DEV_GRP_PREFIX);
export const fiFazgrpRegex = new RegExp('^' + MACROS.DVM.FAZ_GRP_PREFIX);
